export default __webpack_public_path__ + "static/media/logoutarrow.8e806f8f.svg";